import { configureStore } from '@reduxjs/toolkit';
import alertReducer from './reducers/alertReducers';
import { adminUserLoginReducer } from './reducers/adminUserReducers';
import { surveySubmitReducer } from './reducers/surveyReducers';

const adminUserInfoFromStorage = localStorage.getItem('adminUserInfo')
  ? JSON.parse(localStorage.getItem('adminUserInfo'))
  : null;

const preloadedState = {
  adminUserLogin: { adminUserInfo: adminUserInfoFromStorage },
};

const store = configureStore({
  reducer: {
    adminUserLogin: adminUserLoginReducer,
    surveySubmit: surveySubmitReducer,
    alert: alertReducer,
  },
  preloadedState,
  // Redux Toolkit includes thunk middleware by default
  // and configures Redux DevTools automatically
});

export default store;
